import memoize from 'memoize-one';
import {AreaChartData} from 'views/storyboard/charts/area/AreaChartWrapper';
import {BarChartData} from 'views/storyboard/charts/bar/BarChartWrapper';
import {LineChartData} from 'views/storyboard/charts/line/LineChartWrapper';
import {PieChartData} from 'views/storyboard/charts/pie/PieChartWrapper';

type SummableChartData = (
    AreaChartData | BarChartData | LineChartData | PieChartData
    );

export const getChartDataTotal = memoize(
    // Calculates the total for every key for every data point and adds it together
    (
        data: SummableChartData[],
        dataKeys: string[],
        excludedKeys: string[] = [],
    ) => {

        if (!data || data.length === 0 || !dataKeys || dataKeys.length === 0) {
            return 0;
        }

        const total = dataKeys
            .filter((key) => !excludedKeys.includes(key))
            .reduce(
                (keyAccumulator: number, keyCurrentValue: string) =>
                    keyAccumulator +
                    data.reduce((dataAccumulator: number, dataCurrentValue: SummableChartData) => {
                        const val = dataCurrentValue?.[keyCurrentValue as keyof SummableChartData];
                        return dataAccumulator + (typeof val === 'number' ? val : 0);
                    }, 0),
                0
            );

        return Math.round(total * 100) / 100;
    }
);
